import { render, staticRenderFns } from "./cancellingDetails.vue?vue&type=template&id=5c33d517&scoped=true&"
import script from "./cancellingDetails.vue?vue&type=script&lang=js&"
export * from "./cancellingDetails.vue?vue&type=script&lang=js&"
import style0 from "./cancellingDetails.vue?vue&type=style&index=0&id=5c33d517&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c33d517",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c33d517')) {
      api.createRecord('5c33d517', component.options)
    } else {
      api.reload('5c33d517', component.options)
    }
    module.hot.accept("./cancellingDetails.vue?vue&type=template&id=5c33d517&scoped=true&", function () {
      api.rerender('5c33d517', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/mining/staking/cancellingDetails.vue"
export default component.exports